/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProvinceResponseDto } from './ProvinceResponseDto';
import {
    ProvinceResponseDtoFromJSON,
    ProvinceResponseDtoFromJSONTyped,
    ProvinceResponseDtoToJSON,
    ProvinceResponseDtoToJSONTyped,
} from './ProvinceResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListProvincesResponseDto
 */
export interface ListProvincesResponseDto {
    /**
     * 
     * @type {Array<ProvinceResponseDto>}
     * @memberof ListProvincesResponseDto
     */
    data: Array<ProvinceResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListProvincesResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListProvincesResponseDto interface.
 */
export function instanceOfListProvincesResponseDto(value: object): value is ListProvincesResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListProvincesResponseDtoFromJSON(json: any): ListProvincesResponseDto {
    return ListProvincesResponseDtoFromJSONTyped(json, false);
}

export function ListProvincesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListProvincesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ProvinceResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListProvincesResponseDtoToJSON(json: any): ListProvincesResponseDto {
    return ListProvincesResponseDtoToJSONTyped(json, false);
}

export function ListProvincesResponseDtoToJSONTyped(value?: ListProvincesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ProvinceResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

